<template>
  <section class="container-fluid">
    <div class="has-text-centered">
      <div>
        <grid
          :entityTypeId="coachRelationshipEntityTypeId"
          :formId="-1"
          :entityTypeName="''"
          :showFormOnEmpty="false"
          :showAddButton="false"
          :primaryEntity="getPrimaryEntity()"
          :showDisable="false"
          :showEdit="false"
          :showView="false"
          :allowDownload="false"
          ref="coachesGrid"
          :additionalShowColumns="additionalColumns"
          :additionalActions="additionalActions"
          :additionalActionsOnColumn="true"
          :withinModal="withinModal"
          :basePageSize="gridPageSize"
          :baseCurrentPage="gridCurrentPage"
          @setPageSize="setPageSize"
          @setCurrentPage="setCurrentPage"
        ></grid>
      </div>
    </div>
  </section>
</template>

<script>
import RequestPromptRequired from '../../utility/dialog/request-prompt-required';
import { mapGetters } from 'vuex';
export default {
  name: 'UserCoachHistory',
  data() {
    return {
      userEntityTypeId: 1,
      coachRelationshipEntityTypeId: 21,
      additionalColumns: ['primaryEntityName', 'coachName'],
      additionalActions: [
        {
          title: 'End Coaching',
          icon: 'user-minus',
          click: this.closeCoach,
          check: this.shouldShowCloseLink
        }
      ],
      actionStatuses: {
        requested: 1,
        approved: 2,
        rejected: 3,
        closed: 4,
        withdrawn: 5,
        pdpShared: 6,
        pdpShareRemoved: 7
      },
      isDirty: false,
      gridPageSize: 5,
      gridCurrentPage: 1
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    setPageSize(size) {
      this.gridPageSize = parseInt(size);
    },
    setCurrentPage(page) {
      this.gridCurrentPage = parseInt(page);
    },
    getPrimaryEntity() {
      return {
        Id: this.user.id,
        EntityTypeId: this.userEntityTypeId
      };
    },
    shouldShowCloseLink(item) {
      return item.active;
    },
    async closeCoach(item) {
      const action = this.actionStatuses.closed;
      const title = 'End Coaching';
      let text = 'Are you sure you want to end the coaching';

      if (item.primaryEntityName && item.coachName) {
        text = text + ' between ' + item.primaryEntityName + ' and ' + item.coachName;
      }
      text = text + '?';
      await this.performAction(action, item.id, title, text);
    },
    async performAction(action, itemId, promptTitle, promptText) {
      return await new Promise((resolve, reject) => {
        promptText = promptText + ' If so, please enter a comment and click Continue.';
        const options = {
          title: promptTitle,
          okLabel: 'Continue',
          cancelLabel: 'Cancel',
          prompt: {
            invalidMessage: '',
            component: RequestPromptRequired
          }
        };
        this.$dialogs
          .prompt(promptText, options)
          .then((res) => {
            //if we clicked continue
            if (res && res.ok && res.ok == true) {
              const body = {
                coachRelationshipId: itemId,
                action: action,
                comments: res.value
              };
              this.isBusy = true;
              this.$store
                .dispatch('coachRelationshipActionRequest', body)
                .then(async (response) => {
                  this.isBusy = false;
                  if (this.$refs.coachesGrid && this.$refs.coachesGrid.loadSummary)
                    await this.$refs.coachesGrid.loadSummary();
                  resolve(true);
                })
                .catch((errors) => {
                  this.isBusy = false;
                  reject(errors);
                });
            }
            //we closed the window
            resolve(false);
          })
          .catch((error) => reject(error));
      });
    },
    async dirtyCheck() {
      return await new Promise((resolve, reject) => {
        if (this.isDirty && this.isAuthenticated) {
          const options = {
            title: 'Unsaved Data Warning',
            cancelLabel: 'Cancel'
          };
          this.$dialogs
            .confirm('Are you sure you want to close without saving?', options)
            .then((res) => {
              if (res && res.ok && res.ok == true) {
                this.$emit('dirty', false);
                this.isDirty = false;
                resolve(true);
              }
              resolve(false);
            })
            .catch((error) => {
              resolve(false);
            });
        } else resolve(true);
      });
    },
    formDirty(eventVal) {
      this.isDirty = eventVal;
      this.$emit('dirty', eventVal);
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    withinModal: {
      type: Boolean,
      default: true
    }
  }
};
</script>
